export default __webpack_public_path__ + "static/media/back-1.6f68e48e.svg";